"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  MonoValue,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const nodes = [
  { label: "Supplier lead time", value: "12 days", status: "optimal" as const, note: "-3d MoM" },
  { label: "Port congestion", value: "Elevated", status: "caution" as const, note: "LA / Long Beach" },
  { label: "Freight rate index", value: "1,842", status: "alert" as const, note: "+9% WoW" },
  { label: "On-time delivery", value: "94%", status: "optimal" as const, note: "Above target" },
]

const toneColor = {
  optimal: "var(--color-optimal)",
  caution: "var(--color-caution)",
  alert: "var(--color-alert)",
}

const Flow = styled.div`
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`

const Node = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 1rem;
  background: color-mix(in oklch, var(--color-muted) 50%, transparent);
  border: 1px solid color-mix(in oklch, var(--color-border) 50%, transparent);
  padding: 0.75rem 1rem;
`

const StatusDot = styled.span<{ $tone: keyof typeof toneColor }>`
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 9999px;
  flex-shrink: 0;
  background: ${(p) => toneColor[p.$tone]};
`

const NodeInfo = styled.div`
  min-width: 0;
`

const NodeLabel = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-card-foreground);
`

const NodeNote = styled.p`
  margin: 0.0625rem 0 0;
  font-size: 0.75rem;
  color: var(--color-muted-foreground);
`

const NodeValue = styled.div`
  margin-left: auto;
  flex-shrink: 0;
`

export function SupplyChainCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Supply chain health</Title>
          <Subtitle>Logistics &amp; supplier signals</Subtitle>
        </TitleGroup>
        <Badge tone="caution">Watch</Badge>
      </CardHeader>

      <Flow>
        {nodes.map((n) => (
          <Node key={n.label}>
            <StatusDot $tone={n.status} />
            <NodeInfo>
              <NodeLabel>{n.label}</NodeLabel>
              <NodeNote>{n.note}</NodeNote>
            </NodeInfo>
            <NodeValue>
              <MonoValue $tone={n.status}>{n.value}</MonoValue>
            </NodeValue>
          </Node>
        ))}
      </Flow>
    </Card>
  )
}

export default SupplyChainCard
